export interface Career {
  id: string;
  title: string;
  department: string;
  location: string;
  type: 'Full-time' | 'Part-time' | 'Contract';
  description: string;
  requirements: string[];
  responsibilities: string[];
  benefits: string[];
  salary?: string;
}

export const availableCareers: Career[] = [
  {
    id: 'installer',
    title: 'Bidet Installer',
    department: 'Operations',
    location: 'New York City Area',
    type: 'Full-time',
    description: 'Join our team as a professional bidet installer and help bring modern hygiene solutions to homes across New York. We\'re looking for skilled technicians who are passionate about quality workmanship and excellent customer service.',
    requirements: [
      // 'Valid driver\'s license and reliable transportation',
      'You should be handy with tools (ideally, you have experience in either plumbing, electrical, handyman work, general contracting, or tinkering)',
      'Strong problem-solving skills and attention to detail',
      'Excellent communication and customer service skills',
      'Ability to lift up to 50 pounds and work in various physical positions',
      'Professional appearance and demeanor'
    ],
    responsibilities: [
      'Install bidet systems in residential and commercial properties',
      'Perform pre-installation assessments and measurements',
      'Ensure proper electrical and plumbing connections',
      'Test installations for proper functionality and safety',
      'Provide customer education on bidet operation and maintenance',
      'Maintain accurate installation records and paperwork',
      'Follow all safety protocols and company procedures'
    ],
    benefits: [
      'Competitive hourly wage ($25-35/hour based on experience)',
      'Paid time off',
      'Ongoing training opportunities',
      'Performance bonuses and advancement opportunities'
    ],
    salary: '$50,000 - $70,000 annually',
  }
];

export const getCareerById = (id: string): Career | undefined => {
  return availableCareers.find(career => career.id === id);
};

export const getAllCareers = (): Career[] => {
  return availableCareers;
};
